<template>
  <div class="alert alert--small">
    <h4>
      {{ i18n['following_persons_are_on_the_lesson_but_not_on_school'] }} {{ activeSchoolName }}.
    </h4>
    <div class="d-cal__group">
      <div class="d-cal-not-on-school" :data-cal-id="calendar.calendar_id" v-for="calendar in usersNotOnSchool" :key="calendar.calendar_id">
        {{ calendar.name }} <span class="do-pill do-pill--custom" v-if="calendar.substitute">{{ i18n['sub'] }}</span>
        <span class="icon__bg-circle icon__bg-circle--danger icon__bg-circle--x-small"
              @click="setTheRemoveCalendar(calendar)"
              :content="i18n['remove']"
              v-tippy="{
                      arrow: true,
                      placement : 'top'
                    }">
                      <span class="icon-cross2"></span></span>
      </div>
    </div>
    <DModal :show-close="false" :isBgOverlay="true" :appendToBody="true" @close="$emit('close')"
            v-if="theRemoveCalendar">
      <div class="d-modal__d-calendar text-dark" :class="{'d-modal__d-calendar--with-actions': true}"
           slot="insertComponent">
        <div class="d-modal__d-calendar__header text-dark">
          <h2>{{ theRemoveCalendar.name }}</h2>
          <div class="d-modal__close icon__bg-circle" @click="setTheRemoveCalendar(null)">
            <span class="icon-cross2"></span>
          </div>
        </div>
        <div class="d-modal__d-calendar__content">
          <div class="alert width-100">
            <h4>{{ i18n['remove'] }} {{ theRemoveCalendar.name }} {{ i18n['from_this_lesson'] }}?</h4>
            <button class="bttn bttn-danger width-100" @click="removeCalendar(theRemoveCalendar)">{{ i18n['remove'] }}
              {{ theRemoveCalendar.name }} {{ i18n['from_this_lesson'] }}
            </button>
          </div>
          <div class="alert" v-if="false">
            <h4 class="marg-1-bottom">{{ i18n['remove_or_replace'] }} {{ theRemoveCalendar.name }} {{ i18n['on'] }}
              {{ event.title }} {{ i18n['onwards'] }}?</h4>
            <CalendarViewDayRemoveOrReplace
              class="width-100 d-event__actions--custom"
              :isPossibleToAdd="false"
              :event="event"
              :calendar="theRemoveCalendar"
              :calendars="userCalendars"
              @updateAndClose="updateAndClose">
            </CalendarViewDayRemoveOrReplace>
          </div>
        </div>
      </div>
    </DModal>
  </div>
</template>

<script>
import DModal from '../common/DModal'
import CalendarViewDayRemoveOrReplace from '../Calendars/CalendarViewDayRemoveOrReplace'

const I18N = {
  da: {
    following_persons_are_on_the_lesson_but_not_on_school: 'Følgende personer er på lektionen, men er ikke tilknyttet ',
    sub: 'Vikar',
    remove: 'Fjern',
    from_this_lesson: 'fra denne lektion',
    remove_or_replace: 'Eller vil du gerne fjerne eller erstatte',
    on: 'på',
    onwards: 'fremadrettet'
  },
  nb: {
    following_persons_are_on_the_lesson_but_not_on_school: 'Følgende personer er lagt til timen, men er ikke tilknyttet ',
    sub: 'Vikar',
    remove: 'Fjern',
    from_this_lesson: 'fra denne timen',
    remove_or_replace: 'Eller vil du fjerne eller erstatte',
    on: 'på',
    onwards: 'fremover'
  },
  en: {
    following_persons_are_on_the_lesson_but_not_on_school: 'The following staff are in the lesson but are not staff on ',
    sub: 'Sub',
    remove: 'Remove',
    from_this_lesson: 'from this lesson',
    remove_or_replace: 'Or would you like to remove or replace',
    on: 'on',
    onwards: 'onwards'
  }
}

export default {
  components: {DModal, CalendarViewDayRemoveOrReplace},
  props: {
    usersNotOnSchool: {
      type: Array,
      default: () => []
    },
    activeSchoolName: {
      default: ''
    },
    event: {
      default: null
    }
  },
  data () {
    return {
      theRemoveCalendar: null
    }
  },
  computed: {
    locale () {
      return this.$store.getters.locale
    },
    i18n () {
      return I18N[this.locale]
    },
    userCalendars () {
      if (this.theRemoveCalendar === null) {
        return this.$store.getters.userCalendars
      } else {
        return this.$store.getters.userCalendars.filter(calendar => calendar.id !== this.theRemoveCalendar.id)
      }
    }
  },
  methods: {
    removeCalendar (calendar) {
      this.$emit('removeCalendar', calendar)
      this.setTheRemoveCalendar(null)
    },
    updateAndClose () {
      this.setTheRemoveCalendar(null)
      this.$emit('updateAndClose')
    },
    setTheRemoveCalendar (calendar) {
      if (calendar === null) {
        this.theRemoveCalendar = null
        return
      }
      const calObj = {
        name: calendar.name,
        id: calendar.calendar_id
      }
      this.theRemoveCalendar = calObj
    }
  }
}
</script>

<style scoped>

.alert {
  position: relative;
  font-weight: normal;
  border: 1px solid #facc17;
  border-radius: 4px;
  padding: 0.75rem;
  font-size: 11px;
  line-height: 1.5;
  color: #a26206;
  max-width: 600px;
  margin-bottom: 1rem;
  background-color: #fefce8;
}

.alert h4 {
  margin-bottom: 0.5rem;
}

.d-cal__group {
  display: flex;
  flex-wrap: nowrap;
  gap: 0.5rem;
}

.d-cal-not-on-school {
  display: inline-flex;
  align-items: center;
  background-color: #fefce8;
  border: 1px solid #facc17;
  color: #a26206 !important;
  font-size: 11px;
  border-radius: 4px;
  padding: 2px 4px;
  line-height: 0;
}

.icon__bg-circle.icon__bg-circle--x-small {
  width: 20px;
  height: 20px;
  margin-left: 0.25rem;
}

.do-pill.do-pill--custom {
  line-height: 1;
  margin-left: 5px;
  background-color: transparent;
  border-color: wheat;
  color: #854d0f;
}

.d-modal__d-calendar {
  width: 400px;
  min-height: 500px;
  max-height: 100vh;
  overflow-y: auto;
  overscroll-behavior-y: contain;
}

.d-modal__d-calendar__header {
  background-color: #ffffff;
  padding: 1rem 2rem;
  justify-content: space-between;
  align-items: center;
  height: 45px;
  border-bottom: 1px solid var(--border-color);
  border-radius: 0.25rem 0.25rem 0 0;
}

.d-modal__d-calendar__content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 2rem;
  width: 300px;
  margin: 0 auto;
}

.d-event__actions.d-event__actions--custom {
  padding: 0;
  margin: 0;
  border: none;
}

.d-event__actions.d-event__actions--custom h3 {
  display: none;
}

</style>



// WEBPACK FOOTER //
// DCalendarShowEventUsersNotOnSchool.vue?69b3e270